import { ReactNode, useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import { PageTitle } from './PageTitle';
import { Footer } from './Footer';

type Props = {
    title?: string;
    children: ReactNode;
}

export const BasePage = ({ title, children }: Props) => {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [isFooterFixed, setIsFooterFixed] = useState(false);

    useEffect(() => {
        if (contentRef.current) {
            const contentHeight = contentRef.current.offsetHeight;
            setIsFooterFixed(window.innerHeight > contentHeight + 112);
        }
    }, []);

    return (
        <Grid container direction="column" height="100%">
            {title && (
                <Grid item>
                    <PageTitle>{title}</PageTitle>
                </Grid>
            )}
            <Grid item xs overflow="auto">
                <Grid item xs ref={contentRef}>
                    {children}
                </Grid>
                {!isFooterFixed && <Grid item mt={2}>
                    <Footer />
                </Grid>}
            </Grid>
            {isFooterFixed && <Grid item>
                <Footer />
            </Grid>}
        </Grid>
    )
}
